export default __webpack_public_path__ + "static/media/oracle.556d9d47.svg";